export default function isPositiveValidator() {
  const directive = {
    restrict: 'A',
    require: '?ngModel',
    link: _link,
  };

  function _link(scope, element, attributes, ngModel) {
    ngModel.$validators.isPositive = (modelValue, viewValue) => {
      if (ngModel.$isEmpty(modelValue)) {
        // consider empty models to be valid
        return true;
      }

      return viewValue > 0;
    };
  }

  return directive;
}
